import React, { useEffect, useState } from 'react'

import { useInView } from 'react-cool-inview'

import { number, array } from 'prop-types'

import { CommentsProvider } from 'Pods/Shared/Comments/Context/CommentsContext'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'


let CommentsContainer

function CommentsSection({ itemId, initialComments = EMPTY_ARRAY }) {
  const [loadedComponent, setLoadedComponent] = useState(false)
  const [userData, setUserData] = useState(null)
  const { observe, inView } = useInView({
    rootMargin: '-200px',
    threshold: 0.25,
  })

  useEffect(() => {
    if (inView && !loadedComponent) {
      import('Pods/Shared/Comments/CommentsContainer')
        .then((module) => {
          CommentsContainer = module.default
          setLoadedComponent(true)
        })
        .catch((err) => {
          // To do:
          // sentry error here.
        })
    }

    App.events.subscribe('app:user-info:updated', getUserInfo)

    return () => {
      App.events.unsubscribe('app:user-info:updated', getUserInfo)
    }
  }, [inView])

  function getUserInfo() {
    if (typeof window !== undefined && window.pageConfig && !userData) {
      const {
        currentUserAvatarUrl,
        currentUserEmail,
        currentUserId,
        currentUserIsAdmin,
        currentUserProfile,
        currentUserUsername,
      } = window.pageConfig

      setUserData({
        currentUserAvatarUrl,
        currentUserEmail,
        currentUserId,
        currentUserIsAdmin,
        currentUserProfile,
        currentUserUsername,
      })
    }
  }

  return (
    <div className="container comments-section" ref={observe}>
      <div className="row">
        <div className="col-12">
          <h2 className="cgt-legacy-heading-h3 cgt-legacy-text--align-center comments-section__title">
            Comments
          </h2>
          <CommentsProvider itemId={itemId} initialComments={initialComments}>
            {loadedComponent && !!CommentsContainer && (
              <CommentsContainer userData={userData} />
            )}
          </CommentsProvider>
        </div>
      </div>
    </div>
  )
}

CommentsSection.propTypes = {
  itemId: number.isRequired,
  initialComments: array,
}

export default CommentsSection
